import { HOME_PROJECT_LABEL } from '@/lib/appConstants.js';
import normalizeProjectId from '@/lib/normalizeProjectId.js';
import { HOME_PROJECT_ID } from '@/redux/selectors/pieveSelectors/constants.js';

const getThreadProjectLabel = ({ threadMeta, projectMetaById }) => {
  const projectId = normalizeProjectId(threadMeta?.projectId || threadMeta?.project?.id || threadMeta?.project?.projectId || threadMeta?.project_id);

  if (!projectId || projectId === HOME_PROJECT_ID) {
    return HOME_PROJECT_LABEL;
  }

  const projectNameFromMeta = String(projectMetaById?.[projectId]?.name || '').trim();

  if (projectNameFromMeta) {
    return projectNameFromMeta;
  }

  const projectNameFromThread = String(threadMeta?.project?.name || threadMeta?.project?.title || threadMeta?.project?.label || '').trim();

  if (projectNameFromThread) {
    return projectNameFromThread;
  }

  return '';
};

export default getThreadProjectLabel;
